import { Component, OnInit, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { UtilityService } from '../../services/utility.service';
import { UserService } from '../../services/user.service';
import { MasterMOMService } from '../../services/master-mom.service';
import { ToastrUtilsService } from './../../services/toastr-utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { usermaster, division } from '../../models/admin';
import { GenInfoAtd, AttendeesAtd } from '../../models/MOMForm';
import Notiflix from "notiflix";

import { Users, pairText } from '../../models/users';
import { AdminService } from '../../services/admin.service';
import { RSAHelper } from '../../models/RSAHelper';
@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  providers: [ToastrUtilsService]
})

export class UserMasterComponent implements OnInit {

  todayTime = new Date().toLocaleTimeString();
  todayDate = new Date().toLocaleDateString();
  isView: boolean = false;
  @ViewChild('userMasterAdd', { static: false }) userMasterAdd: TemplateRef<any>;
  public data: any=[];
  public user_data: any=[];
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
 
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  model: any = {};
  public permission: number = 1;
  user: any = {};
  login_UserID: number; // number
    modalRef: any;
  public meetingTypeForm: FormGroup;
    dataList: any=[];
  searchText: any = '';UserList: any=[];
    tempuseraccess: boolean=false;
    strK1: string;
    strI1: string;
;
    locationUno_data: any=[];
  division_data: any = [];
  userInfoList = new usermaster();
    meetingList: any=[];
    disableMore: boolean;
  isEdit: boolean;

    userFollowUpList: any;
    isNTLogin: boolean;
  ntUserDataList: any = [];
  PostStartIndex: number = 1;
  PostMaxCount: number = 10;
    ntUser: string;
    ifcountgreaterthanzero: boolean;
  noDataImage: string;
  exUser: boolean = false;
    externalUser: any=0;
  followUpUserList: any = [];
  isDelegate: boolean = false;
  isLoader: boolean;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  loading:boolean = false;
  public accessValue = [{ value: 1, text: 'Read Access' }, { value: 2, text: 'Full Access' }];
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private modalService: BsModalService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    public restApi: AdminService,
    private _router: Router,
   ) { }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.disableMore) {
        this.disableMore = true;

        this.getMoreUsers();
      }

    }
  }
  ngOnInit() {
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
  
    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.login_UserID = user.id;
      var Role = Number(user.role);
      this.loadpairText();
      if (Role != 1) {
        this._router.navigate(['/dashboard'])
      }
    }

    this.activatedRoute.queryParams
      .subscribe(params => {

        if (params.isusermanage)
          this.tempuseraccess = true;
        else {
          this.tempuseraccess = false;
        }

      }
      );
    this.getDivisions();
    this.loadUserMaster(true);
    this.ifcountgreaterthanzero = false;
    this.PostMaxCount = 10;
    this.getUserList();

   
  }

  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  redirectResetMeetingAction() {
    this._router.navigate(['/resetmeetingaction']);
  }
  //Get User List
  getUserList() {
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.login_UserID;
    this.momMasterservice.getUserList(inpValue)
      .subscribe(data => {
        this.UserList = data;
      },
        () => {
        }
      ).add(() => {
      });
  }
 
  getMoreUsers() {
    this.loadUserMaster(false);
  }

  getDivisions() {

    let inpValue = new division();
    //inpValue.id = 3;
    inpValue.languageUno = 1033;
    inpValue.condition = 1;

    this.momMasterservice.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  loadUserMaster(isStart: boolean) {
    ;
   // Notiflix.Loading.Standard('Please Wait...', '.pageloadcontainer');
   // Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader = true;
    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.searchText = this.searchText;
    inpValue.condition = 1;
    this.PostStartIndex = (this.PostStartIndex == undefined || this.PostStartIndex < 1 || isStart) ? 1 : this.PostStartIndex;
    inpValue.startIndex = this.PostStartIndex;
    inpValue.maxCount = this.PostMaxCount;
    this.momMasterservice.getUserMasters(inpValue)
      .subscribe(data => {
        ;
        this.loading = false;
        if (this.PostStartIndex == 1) {
          this.user_data = [];
        }
        let dataItemList: any = [];
        dataItemList = data;
        for (var i = 0; i < dataItemList.length; i++) {
          
          this.user_data.push(dataItemList[i]);
        }
      
        this.dataList = data;
        console.log("usermaster", data);
        this.disableMore = (dataItemList.length >= 10) ? false : true;
        if (dataItemList.length > 0) {
          this.ifcountgreaterthanzero = true;
          this.PostStartIndex = this.PostStartIndex + 1;
        }
        this.isLoader = false;
     //Notiflix.Block.Remove('.pageloadcontainer',800);
       
      },
        (error) => {
      //  Notiflix.Block.Remove('.pageloadcontainer', 800);
         // this.spinner.hide();
        }
      ).add(() => {
     // Notiflix.Block.Remove('.pageloadcontainer', 800);
///this.spinner.hide();
      });
  }

  exportExcel() {


    let items: any = [];
    const wb: any = { SheetNames: [], Sheets: {} };
    let filename = 'master.xlsx';



    for (var i = 0; i < this.user_data.length; i++) {
      items.push({
        ID: i + 1,
        DisplayName: this.user_data[i].displayNameEn,
        Designation: this.user_data[i].designationEn,
        PRNumber: this.user_data[i].prNumber,
        EmailId: this.user_data[i].emailId,
        DivisionName: this.user_data[i].divisionNameEn
      });
    }
    filename = 'UserMaster.xlsx'
    var ws = XLSX.utils.json_to_sheet(items);
    wb.SheetNames.push("usermaster"); wb.Sheets["usermaster"] = ws;


    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataVal: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    if (window.navigator.msSaveBlob) //IE & Edge
    {
      //msSaveBlob only available for IE & Edge
      window.navigator.msSaveBlob(dataVal, filename);
    }
    else //Chrome & FF
    {
      var url = window.URL.createObjectURL(dataVal);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }
  }

  openModal(template2: TemplateRef<any>, add: any) {
    ;

    this.pageAction = add;
    this.getSelUserAtd();
    this.model.ntLoginName = '';
    this.model.prnNumber = '';
    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable modal-body-scrollable' }, this.ngbModalOptions)
    );
    if (this.pageAction == "add") { 
      this.isEdit = false;
      this.model.prNumber = '';
      this.model.displayNameEn = '';
      this.model.displayNameAr = '';
      this.model.emailId = '';
      this.model.firstname = '';
      this.model.lastname = '';
      this.model.designationEn = '';
      this.model.designationAr = '';
      this.model.divisionUno = null;
      this.model.ntLoginName = '';
      this.model.followUp = null;
      this.model.startDate = '';
      this.model.endDate = '';
      this.model.access = null;
      this.model.password = '';
      this.model.confirmPassword = '';
      this.isDelegate =false;
      this.isNTLogin = false;
      this.loadNTUserMaster();
      this.changeSearch('nt');
    }

    else if (this.pageAction == "edit") {
     
      this.isEdit = true;
      this.isNTLogin = false;
    }
    //this.modalPub.hide();
  }
  
 
  
  AddEditUserMaster() {

    ;
    if (this.compareDate(this.model.startDate, this.model.endDate)) {
      this.toastr.ErrorCustomMessage('Start date should be lesser than End date');
      return false;
    }

    if (this.DuplicateNameCheck(this.utilityService.isStringNull(this.model.emailId), this.model.id)) {

      this.toastr.ErrorCustomMessage('Duplicates not allowed');
      return false;
    }
    if (this.model.displayNameEn.trim() == '' && this.model.displayNameAr.trim() == '' && this.model.emailId.trim() == '' && this.model.firstname.trim() == ''
      && this.model.lastname.trim() == '' && this.model.designationEn.trim() == '' && this.model.designationAr.trim() == '') {
      this.toastr.ErrorCustomMessage('Please enter required values');
      return false;
    }
      
    let obj = new usermaster();
    obj.id = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.model.id);
    obj.actionType = this.pageAction;
    obj.ntUsername = this.utilityService.isStringNull(this.model.ntLoginName);
    obj.prNumber = this.utilityService.isStringNull(this.model.prNumber);
    obj.displayNameEn = this.utilityService.isStringNull(this.model.displayNameEn);
    obj.displayNameAr = this.utilityService.isStringNull(this.model.displayNameAr);
    obj.emailId = this.utilityService.isStringNull(this.model.emailId);
    obj.firstname = this.utilityService.isStringNull(this.model.firstname);
    obj.lastname = this.utilityService.isStringNull(this.model.lastname);
    obj.designationEn = this.utilityService.isStringNull(this.model.designationEn);
    obj.designationAr = this.utilityService.isStringNull(this.model.designationAr);
    obj.divisionUno = this.model.divisionUno != '' && this.model.divisionUno != undefined && this.model.divisionUno != null ? this.model.divisionUno:0;
    obj.followUp = this.model.followUp != '' && this.model.followUp != undefined && this.model.followUp != null ? this.model.followUp:0;
    var objRSAHelper = new RSAHelper();

    if(this.model.password !== undefined){
      var password = objRSAHelper.encryptWithPublicKey(this.model.password);
      var confirmPassword = objRSAHelper.encryptWithPublicKey(this.model.confirmPassword);
      obj.password = this.utilityService.isStringNull(password);
      obj.confirmPassword = this.utilityService.isStringNull(confirmPassword);
    }
    
    obj.startDate = this.utilityService.isStringNull(this.model.startDate);
    obj.endDate = this.utilityService.isStringNull(this.model.endDate);
    obj.isAccess = this.model.access != '' && this.model.access != undefined && this.model.access != null ? this.model.access:0 ;
    obj.isDelegate = this.isDelegate == true? 1:0;
    obj.externalUser = this.externalUser;
    obj.userUno = this.login_UserID;
      
    this.momMasterservice.addEditUserMaster(obj)
      .subscribe((data) => {
        if (data == "Success") {
          this.toastr.SaveMessage();
          this.loadUserMaster(true);
          this.modalRef.hide();
        }
        else {
          this.toastr.ErrorMessage();
        }

          //this.spinner.hide();
        },
          () => {
            //Called when error
            this.toastr.ErrorMessage();
           // this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    
  }

  editUserMaster(data: any) {
    ;
    this.pageAction = "edit";
    this.model.id = this.utilityService.isNumericNull(data.id);
    this.model.prNumber = this.utilityService.isStringNull(data.prNumber);
    this.model.displayNameEn = this.utilityService.isStringNull(data.displayNameEn);
    this.model.displayNameAr = this.utilityService.isStringNull(data.displayNameAr);
    this.model.emailId = this.utilityService.isStringNull(data.emailId);
    this.model.firstname = this.utilityService.isStringNull(data.firstname);
    this.model.lastname = this.utilityService.isStringNull(data.lastname);
    this.model.designationEn = this.utilityService.isStringNull(data.designationEn);
    this.model.designationAr = this.utilityService.isStringNull(data.designationAr);
    this.model.divisionUno = this.utilityService.isNumericNull(data.divisionUno);
    this.ntUser = this.utilityService.isStringNull(data.ntUsername);
    this.model.followUp = this.utilityService.isNumericNull(data.followUp);
    this.model.access = this.utilityService.isNumericNull(data.isAccess);
    this.model.startDate = this.utilityService.isStringNull(data.startDate);
    this.model.endDate = this.utilityService.isStringNull(data.endDate);
    this.isDelegate = data.isDelegate == 1 ? true : false;
    this.exUser = data.externalUser == 1 ? true : false;
  }

  DuplicateNameCheck(emailId: string, id: number) {
    var rtnValue = false;
    if (this.data != null && this.data != undefined) {
     
      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.emailId.toLocaleLowerCase() == emailId.toLocaleLowerCase() && id != grdData.id) {
          rtnValue = true;
        }
      });

      
    }
    return rtnValue;
  }


  DeleteConfirm(data: any) {
    let temp = this;
    Notiflix.Confirm.Show('Delete Confirm', 'Are you sure you want to delete this record?', 'Yes', 'No', function () {

      Notiflix.Loading.Standard('Loading...');
      temp.DeleteUserMaster(data);

    }, function () { // No button callback
      return false;
    });

  }
  DeleteUserMaster(data1: any) {
    let obj = new usermaster();
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    //objDeaprtment.tenantUno = 1;
    obj.condition = 2;
    this.momMasterservice.deleteUserMaster(obj)
      .subscribe(() => {
        
        this.toastr.DeleteMessage();
        this.loadUserMaster(true);
        setTimeout(() => {

          Notiflix.Loading.Remove();
        }, 400);
       // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }



  ResetConfirm(data: any) {
    let temp = this;
    Notiflix.Confirm.Show('Delete Confirm', 'Are you sure you want to reset this record?', 'Yes', 'No', function () {

      Notiflix.Loading.Standard('Loading...');
      temp.ResetUserMaster(data);

    }, function () { // No button callback
      return false;
    });

  }
 ResetUserMaster(data1: any) {
    let obj = new usermaster();
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    //objDeaprtment.tenantUno = 1;
    obj.condition =3;
    this.momMasterservice.deleteUserMaster(obj)
      .subscribe(() => {

        this.toastr.SaveMessage();
        this.loadUserMaster(true);
        setTimeout(() => {

          Notiflix.Loading.Remove();
        }, 400);
        // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  searchGrid() {
    ;
    if (this.searchText != "") {
      this.user_data = this.dataList.filter(a =>
        a.prNumber && a.prNumber.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.displayNameEn && a.displayNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.emailId && a.emailId.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.firstname && a.firstname.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.lastname && a.lastname.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.designationEn && a.designationEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.designationAr && a.designationAr.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionNameEn && a.divisionNameEn.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.user_data = this.dataList;
  }

  userInfo(data: any) {
    this.userInfoList = data;
    this.loadGeneralInfo(data.id);
    this.loadFollowUpUser(data.id);
  }

  // Get GeneralInfo list
  loadGeneralInfo(id) {
    Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new GenInfoAtd();
    inpValue.userUno = id;
    inpValue.actionType = "MEETING";
    inpValue.genInfoAtdUno = 0;
    inpValue.recordType = 1;

    this.momMasterservice.getGeneralInfoAtd(inpValue)
      .subscribe((data: any) => {
        this.meetingList = data;
        Notiflix.Block.Remove('.pageloadcontainer', 500);
        //this.spinner.hide();

      },
        () => {
          //this.spinner.hide();
          Notiflix.Block.Remove('.pageloadcontainer', 500);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       // this.spinner.hide();
        Notiflix.Block.Remove('.pageloadcontainer', 500);
      });

  }
  

  //Get User List
  getSelUserAtd() {
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.login_UserID;
    if (this.userService.UserList.length == 0) {
      this.momMasterservice.getUserList(inpValue)
        .subscribe(data => {
          this.userService.UserList = data;
          this.userFollowUpList = this.userService.UserList;

        },
          () => {

          }
        ).add(() => {
          //Called when operation is complete (both success and error)
        });
    }
    else {

    }
  }


  // Get user list
  loadNTUserMaster() {
   
    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    inpValue.condition =5;
    this.momMasterservice.getUserMasters(inpValue)

      .subscribe(data => {

        this.ntUserDataList = data;

        console.log(this.ntUserDataList ,"ntuser");
        //this.spinner.hide();
      },
        (error) => {
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       
      });
  }


  changeSearch(val: any) {
    ;
    if (val == 'pr') {
      this.isNTLogin = true;
      this.exUser = false;
      this.externalUser = 0;
    }
    else if (val == 'nt') {
      this.isNTLogin = false;
      this.exUser = false;
      this.externalUser = 0;
    }
    else if (val == 'ex') {
      this.isNTLogin = false;
      this.exUser = true;
      this.externalUser = 1;
    }

   // this.isNTLogin = (val == 'pr') ? true : false;
    this.model.prNumber = '';
    this.model.displayNameEn = '';
    this.model.displayNameAr = '';
    this.model.emailId = '';
    this.model.firstname = '';
    this.model.lastname = '';
    this.model.designationEn = '';
    this.model.designationAr = '';
    this.model.divisionUno = null;
    this.model.ntLoginName = '';
    this.model.password = '';
    this.model.confirmPassword = '';
    return false;
  }

  onchangeNTUser(value) {

    ;

    if (!this.isNTLogin) {
      let ntuserfilter = this.ntUserDataList.filter(x => x.ntUsername == value);
      this.model.displayNameEn = this.utilityService.isStringNull(ntuserfilter[0].displayNameEn);
      this.model.displayNameAr = this.utilityService.isStringNull(ntuserfilter[0].displayNameAr);
      this.model.designationAr = this.utilityService.isStringNull(ntuserfilter[0].designationAr);
      this.model.designationEn = this.utilityService.isStringNull(ntuserfilter[0].designationEn);
      this.model.divisionUno = this.utilityService.isNumericNull(ntuserfilter[0].divisionUno);
      this.model.firstname = this.utilityService.isStringNull(ntuserfilter[0].firstname);
      this.model.lastname = this.utilityService.isStringNull(ntuserfilter[0].lastname);
      this.model.emailId = this.utilityService.isStringNull(ntuserfilter[0].emailId);
      this.model.prNumber = this.utilityService.isStringNull(ntuserfilter[0].prNumber);
    }
    else if (this.isNTLogin){
      let ntuserfilter = this.ntUserDataList.filter(x => x.prNumber == value);
      this.model.displayNameEn = this.utilityService.isStringNull(ntuserfilter[0].displayNameEn);
      this.model.displayNameAr = this.utilityService.isStringNull(ntuserfilter[0].displayNameAr);
      this.model.designationAr = this.utilityService.isStringNull(ntuserfilter[0].designationAr);
      this.model.designationEn = this.utilityService.isStringNull(ntuserfilter[0].designationEn);
      this.model.divisionUno = this.utilityService.isNumericNull(ntuserfilter[0].divisionUno);
      this.model.firstname = this.utilityService.isStringNull(ntuserfilter[0].firstname);
      this.model.lastname = this.utilityService.isStringNull(ntuserfilter[0].lastname);
      this.model.emailId = this.utilityService.isStringNull(ntuserfilter[0].emailId);
      this.model.ntLoginName = this.utilityService.isStringNull(ntuserfilter[0].ntUsername);
    }

  }


  loadFollowUpUser(id:any) {

    //this.spinner.show();
    let inpValue = new usermaster();
    inpValue.userUno = id;
    inpValue.startIndex = 1;
    inpValue.maxCount = 10;
    this.momMasterservice.getFollowUpUsers(inpValue)

      .subscribe(data => {

        this.followUpUserList = data;

        console.log(this.followUpUserList, "followUpUser");
        //this.spinner.hide();
      },
        (error) => {
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }


  compareDate(startDate: any, endDate: any) {
    //var d1 = new Date('2020-01-23'); //yyyy-mm-dd  
    //var d2 = new Date('2020-01-21'); //yyyy-mm-dd
    let returnValue: boolean = false;
    let d1 = new Date(startDate);
    let d2 = new Date(endDate);
    if (d1 > d2) {
      returnValue = true;
    }



    return returnValue;
  }

  updateCacheUser() {
    let inpValue = new usermaster();
    inpValue.userUno = this.login_UserID;
    this.momMasterservice.updateCacheUser(inpValue).subscribe(data => {

      this.toastr.SuccessCustomMessage("Referesh User");
      //this.spinner.hide();
    },
      (error) => {
        //Called when error
        // this.spinner.hide();
      }
    ).add(() => {
      //Called when operation is complete (both success and error)

    });
  }
  switchUserConfirm(Id:any) {
    let temp = this;
    Notiflix.Confirm.Show('Confirm', 'Please confirm to switch the user?', 'Yes', 'No', function () {

      
      temp.switchUser(Id);

    }, function () { // No button callback
      return false;
    });

  }

  switchUser(id: any) {
    let objusers = new Users;
    

    //var userName = atob(id); //this.f.username.value.trim();
    //objusers.userName = userName;//this.usermodel.username;//userName;
    var objRSAHelper = new RSAHelper();

    var userName = objRSAHelper.encryptWithPublicKey(id);
    objusers.userName = userName;
    objusers.tenantUno = 1;
    this.restApi.GetUserInfo_ByUserID(objusers).subscribe(
      data => {

        let objdata: any = data;
        if (objdata != null && objdata.length > 0 && objdata[0] != null) {

          //Get User default information
          var userid = data[0].id;
          var displayname = (data[0].displayName != null && data[0].displayName != '') ? data[0].displayName : '';
          var username = (data[0].userName != null && data[0].userName != '') ? data[0].userName : '';
          var firstname = (data[0].firstName != null && data[0].firstName != '') ? data[0].firstName : '';
          var lastname = (data[0].lastname != null && data[0].lastname != '') ? data[0].lastname : '';
          var email = (data[0].emailId != null && data[0].emailId != '') ? data[0].emailId : '';
          var userPRnumber = (data[0].userPRnumber != null && data[0].userPRnumber != '') ? data[0].userPRnumber : '';
          var isTBT = (data[0].isTBT != null && data[0].isTBT != '') ? data[0].isTBT : false;
          var division = (data[0].division != null && data[0].division != '') ? data[0].division : '';
          var designation = (data[0].designation != null && data[0].designation != '') ? data[0].designation : '';
          var role = (data[0].role != null && data[0].role != '') ? Number(data[0].role) : 0;
          var picture = (data[0].picture != null && data[0].picture != '') ? data[0].picture : '';
          //Assign User value to the Session
          var struser = '{"id":"' + userid + '","displayname":"' + displayname + '","username":"' + username + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","isTBT":"' + isTBT + '","division":"' + division + '","picture":"' + picture + '","role":"' + role + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '"}';
          localStorage.removeItem('userinfo');
          localStorage.setItem('userinfo', struser);
          
          this.toastr.SuccessCustomMessage('User switched..!');
          this._router.navigate(['/dashboard']);

        }
        else {

          
          this.toastr.ErrorCustomMessage('Your Account is locked or not matched, contact your system administrator.')
        }
      },
      error => {
        

        this.toastr.ErrorCustomMessage('SQL or Network connectivity error is occured,  contact your system administrator.');
        
      },
      () => {
       
      });

  }
}
